import { apolloClient } from './apollo'
import {
  APPROVE_ACCREDITATIONS,
  APPROVE_CURATED_INVITEES,
  CREATE_ATTENDEE,
  DENY_ACCREDITATIONS,
  GET_ATTENDEE,
  GET_ATTENDEE_BY_BARCODE,
  GET_ATTENDEE_WORKSHOPS,
} from './graphql/accreditation.graphql'
import {
  CREATE_ANNOUNCEMENT,
  DELETE_ANNOUNCEMENT,
  GET_ANNOUNCEMENT,
  GET_EVENT_ANNOUNCEMENT,
} from './graphql/announcement.graphql'
import {
  ACCEPT_INVITE,
  CREATE_FLOOR_PLAN_PENDING_ACCREDITATION_PUBLIC,
  CREATE_PENDING_ACCREDITATION,
  CREATE_PENDING_ACCREDITATION_PUBLIC,
  CREATE_PURCHASE_ACCREDITATIONS_PUBLIC,
  CREATE_PURCHASE_ACCREDITATIONS_PUBLIC_CONFERENCE_TICKETING,
  GET_AUTHORIZATION,
  GET_USER,
  IS_TOKEN_VALID,
  LOGOUT,
} from './graphql/auth.graphql'
import {
  ACCREDITATION_COUNT,
  CHANGE_EVENT_VENUE,
  CREATE_EVENT,
  GET_EVENT_ADS,
  GET_EVENT_SETTINGS,
  SAVE_ATTENDEE_FIELDS,
  SOFT_DELETE_EVENT,
  TOGGLE_EVENT_APPLICATIONS,
} from './graphql/event.graphql'
import { CREATE_HALL, DELETE_HALL, UPDATE_HALL } from './graphql/halls.graphql'
import {
  CANCEL_ORDER_CONFERENCE_TICKETING,
  CREATE_ORDER,
  FINISH_ORDER,
  GET_ORDER,
  GET_ORDER_INFO_BY_ORDER_NUMBER,
  GET_ORDER_INFO_BY_UUID,
  GET_ORGANIZATION_STORE_ORDER_INFO_BY_UUID,
  POPULATE_ORDER,
  POPULATE_ORDER_DATA_CONFERENCE_TICKETING,
  POPULATE_ORGANIZATION_STORE_ORDER,
  POPULATE_SPORT_ORGANIZATION_STORE_ORDER,
  REFETCH_SELECTED_SEATS_BY_ORDER_UUID,
  UPDATE_ORDER,
} from './graphql/order.graphql'
import {
  CREATE_ORDER_ITEM,
  CREATE_GRATIS_ORDER_ITEM,
  DISCONNECT_ORDER_ITEM_SECTION_SEATS,
  GET_ORDER_ITEM,
  UPDATE_ORDER_ITEM,
  UPDATE_ORDER_ITEM_SECTION_SEATS,
} from './graphql/orderItem.graphql'
import {
  CREATE_PROMO_CODE,
  DELETE_PROMO_CODE,
  DELETE_PROMO_CODES,
  GET_PROMO_CODE_BY_NAME,
  UPDATE_PROMO_CODE,
} from './graphql/promoCode.graphql'
import {
  CREATE_PROVIDER,
  DELETE_PROVIDER,
  RESTORE_PROVIDER,
  UPDATE_PROVIDER,
} from './graphql/provider.graphql'
import { CREATE_REFERRAL, DELETE_REFERRAL } from './graphql/referal.graphql'
import {
  CREATE_EVENT_TRANSLATION,
  CREATE_OR_UPDATE_EVENT_TRANSLATION,
  DELETE_EVENT_TRANSLATION,
} from './graphql/translation.graphql'
import {
  CREATE_TRIAL_ACCOUNT,
  CREATE_USER,
  GET_TICKET_SELLER_ORGANIZATION,
  SIGN_UP,
  UPDATE_USER,
  UPDATE_USER_STATUS,
} from './graphql/user.graphql'
import {
  GET_PURCHASE_SIGNATURE,
  GET_SIGNED_URL,
  GET_WS_PURCHASE_SIGNATURE,
} from './graphql/utils.graphql'
import {
  GET_VENUE_AVAILABILITY,
  RESET_VENUE_AVAILABILITY,
  UPDATE_VENUE_AVAILABILITY,
} from './graphql/venueAvailability.graphql'
import {
  CREATE_WORKSHOP,
  DELETE_WORKSHOP,
  REMOVE_WORKSHOP_ATTENDEE,
  UPDATE_WORKSHOP,
} from './graphql/workshop.graphql'

import Axios from 'axios'
import { GET_ACCREDITATION_INVITE } from './graphql/eventCategoryRequest.graphql'
import { CREATE_PURCHASE, GET_PURCHASE_SUMMARY, GET_EVENT_LEGAL_ENTITY_INVOICES, GET_EVENT_INVOICES_CATEGORIZED } from './graphql/purchase.graphql'
import { DELETE_USER_EVENT } from './graphql/userEvent.graphql'

import { routingUserModelTypes } from './routing/routing-user-model-types'

const axiosInstance = Axios.create({
  baseURL: process.env.VUE_APP_SERVER_URL,
  withCredentials: true,
})

export const uploadImage = (url, file) => {
  const options = {
    headers: {
      'Content-Type': file.type,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    },
  }

  return Axios.put(url, file, options)
}

export const uploadAttendeeCSV = (eventId, file, token, curatedInvitees) => {
  const formData = new FormData()
  formData.append('file', file)

  const url = `files/events/${eventId}/import/${
    curatedInvitees ? 'invitees' : 'attendees'
  }/csv/${token}`
  const options = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }

  return axiosInstance.post(url, formData, options)
}

export const uploadSportSubscriptionsCSV = (organizationSlug, file, token) => {
  const formData = new FormData()
  formData.append('file', file)

  const url = `files/sport-organizations/${organizationSlug}/import/subscriptions/csv/${token}`
  const options = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }

  return axiosInstance.post(url, formData, options)
}

export const uploadSportMembershipsCSV = (organizationSlug, file, token) => {
  const formData = new FormData()
  formData.append('file', file)

  const url = `files/sport-organizations/${organizationSlug}/import/memberships/csv/${token}`
  const options = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }

  return axiosInstance.post(url, formData, options)
}

export const getSignedURL = async path => {
  return (
    await apolloClient.query({
      query: GET_SIGNED_URL,
      variables: { path },
    })
  ).data.getSignedUrl
}

export const getOrderInfoByUUID = async uuid => {
  const response = await apolloClient.query({
    query: GET_ORDER_INFO_BY_UUID,
    variables: { uuid },
  })
  if (!response.data) {
    return null
  }

  return response.data.getOrderInfoByUUID
}
export const getOrganizationStoreOrderInfoByUUID = async uuid => {
  const response = await apolloClient.query({
    query: GET_ORGANIZATION_STORE_ORDER_INFO_BY_UUID,
    variables: { uuid },
  })
  if (!response.data) {
    return null
  }

  return response.data.getOrganizationStoreOrderInfoByUUID
}
export const fetchSelectedSeatsByOrderUUID = async uuid => {
  const response = await apolloClient.query({
    query: REFETCH_SELECTED_SEATS_BY_ORDER_UUID,
    variables: { uuid },
  })
  if (!response.data) {
    return null
  }

  return response.data.fetchSelectedSeatsByOrderUUID
}

export const populateOrderData = async variables => {
  return await apolloClient.mutate({
    mutation: POPULATE_ORDER,
    variables,
  })
}
export const populateOrganizationStoreOrder = async variables => {
  return await apolloClient.mutate({
    mutation: POPULATE_ORGANIZATION_STORE_ORDER,
    variables,
  })
}
export const populateSportOrganizationStoreOrder = async variables => {
  return await apolloClient.mutate({
    mutation: POPULATE_SPORT_ORGANIZATION_STORE_ORDER,
    variables,
  })
}
export const populateOrderDataConferenceTicketing = async variables => {
  await apolloClient.mutate({
    mutation: POPULATE_ORDER_DATA_CONFERENCE_TICKETING,
    variables,
  })
}
export const cancelOrderConferenceTicketing = async variables => {
  await apolloClient.mutate({
    mutation: CANCEL_ORDER_CONFERENCE_TICKETING,
    variables,
  })
}

export const isTokenValid = async () => {
  const result = await apolloClient.mutate({
    mutation: IS_TOKEN_VALID,
  })
  const { isTokenValid: tokenValid } = result.data

  return tokenValid
}

export const logout = async () => {
  await apolloClient.mutate({
    mutation: LOGOUT,
    refetchQueries: [{ query: GET_USER }],
  })
}

export const createPendingAccreditation = async variables => {
  return await apolloClient.mutate({
    mutation: CREATE_PENDING_ACCREDITATION,
    variables,
  })
}

export const createPendingAccreditationPublic = async variables => {
  return await apolloClient.mutate({
    mutation: CREATE_PENDING_ACCREDITATION_PUBLIC,
    variables,
  })
}
export const createFloorPlanPurchaseAccreditationsPublic = async variables => {
  return await apolloClient.mutate({
    mutation: CREATE_FLOOR_PLAN_PENDING_ACCREDITATION_PUBLIC,
    variables,
  })
}

export const updateOrderItemSectionSeats = async variables => {
  return await apolloClient.mutate({
    mutation: UPDATE_ORDER_ITEM_SECTION_SEATS,
    variables,
  })
}

export const updateVenueAvailability = async variables => {
  return await apolloClient.mutate({
    mutation: UPDATE_VENUE_AVAILABILITY,
    variables,
  })
}
export const disconnectOrderItemSectionSeats = async variables => {
  return await apolloClient.mutate({
    mutation: DISCONNECT_ORDER_ITEM_SECTION_SEATS,
    variables,
  })
}
export const getVenueAvailability = async variables => {
  return await apolloClient.query({
    query: GET_VENUE_AVAILABILITY,
    variables,
  })
}

export const createPurchaseAccreditationsPublic = async variables => {
  return await apolloClient.mutate({
    mutation: CREATE_PURCHASE_ACCREDITATIONS_PUBLIC,
    variables,
  })
}
export const createPurchaseAccreditationsPublicConferenceTicketing = async variables => {
  return await apolloClient.mutate({
    mutation: CREATE_PURCHASE_ACCREDITATIONS_PUBLIC_CONFERENCE_TICKETING,
    variables,
  })
}

export const acceptInvite = async (user, inviteToken) => {
  const { data } = await apolloClient.mutate({
    mutation: ACCEPT_INVITE,
    variables: {
      userInfo: user,
      inviteToken,
    },
  })

  return data.acceptInvite
}

export const updateUser = async userInfo => {
  const { data } = await apolloClient.mutate({
    mutation: UPDATE_USER,
    variables: { userInfo },
    refetchQueries: [{ query: GET_USER }],
  })

  return data.updateUser
}

export const getAccreditationInvite = async token => {
  const { data } = await apolloClient.query({
    query: GET_ACCREDITATION_INVITE,
    variables: { token },
  })

  return data.getAccreditationInvite
}

export async function getAuthorization(eventId, organizationSlug, eventTemplateId) {
  const { data } = await apolloClient.query({
    query: GET_AUTHORIZATION,
    variables: { eventId, organizationSlug, eventTemplateId },
  })

  return data.getAuthorization
}

export async function getUser() {
  const { data } = await apolloClient.query({
    query: GET_USER,
  })

  return (data || {}).me
}
export async function getEventSummary(eventId, from, to) {
  const { data } = await apolloClient.query({
    query: GET_PURCHASE_SUMMARY,
    variables: { eventId, from, to },
  })

  return (data || {}).getPurchaseSummary
}
export async function getEventLegalEntityInvoices(eventId) {
  const { data } = await apolloClient.query({
    query: GET_EVENT_LEGAL_ENTITY_INVOICES,
    variables: { eventId },
  })

  return (data || {}).getEventLegalEntityInvoices
}
export async function getEventInvoicesCategorized(eventId) {
  const { data } = await apolloClient.query({
    query: GET_EVENT_INVOICES_CATEGORIZED,
    variables: { eventId },
  })

  return (data || {}).getEventInvoicesCategorized
}

export const createAttendee = async (eventId, categoryId, zones, avatar, fields) => {
  const attendee = { categoryId, zones, avatar, fields }
  const { data } = await apolloClient.mutate({
    mutation: CREATE_ATTENDEE,
    variables: {
      eventId,
      attendee,
    },
  })

  return data.createAttendee
}

export const approveAccreditations = async ({ eventId, attendeeIds, refetchQueries }) => {
  const { data } = await apolloClient.mutate({
    mutation: APPROVE_ACCREDITATIONS,
    variables: {
      eventId,
      attendeeIds,
    },
    refetchQueries,
  })

  return data.approveAccreditations
}
export const approveCuratedInvitees = async ({ eventId, attendeeIds, refetchQueries }) => {
  const { data } = await apolloClient.mutate({
    mutation: APPROVE_CURATED_INVITEES,
    variables: {
      eventId,
      attendeeIds,
    },
    refetchQueries,
  })

  return data.approveCuratedInvitees
}

export const denyAccreditations = async ({ eventId, attendeeIds, refetchQueries }) => {
  const { data } = await apolloClient.mutate({
    mutation: DENY_ACCREDITATIONS,
    variables: {
      eventId,
      attendeeIds,
    },
    refetchQueries,
  })

  return data.denyAccreditations
}

export const updateUserStatus = async ({ status, userId, refetchQueries }) => {
  const { data } = await apolloClient.mutate({
    mutation: UPDATE_USER_STATUS,
    variables: { status, userId },
    refetchQueries,
  })

  return data.updateUserStatus
}

export const removeUserEvent = async ({ userEventId, eventId, refetchQueries }) => {
  await apolloClient.mutate({
    mutation: DELETE_USER_EVENT,
    variables: { id: userEventId, eventId },
    refetchQueries,
  })
}

export const softDeleteEvent = async ({ eventId, refetchQueries }) => {
  await apolloClient.mutate({
    mutation: SOFT_DELETE_EVENT,
    variables: { eventId },
    refetchQueries,
  })
}

export const createUser = async ({ variables, refetchQueries }) => {
  const { data } = await apolloClient.mutate({
    mutation: CREATE_USER,
    variables,
    refetchQueries,
  })

  return data.createUser
}

export const createOrUpdateEventTranslation = async (eventId, translationData, refetchQueries) => {
  const { data } = await apolloClient.mutate({
    mutation: CREATE_OR_UPDATE_EVENT_TRANSLATION,
    variables: {
      eventId,
      translationData,
    },
    refetchQueries,
  })

  return data.createOrUpdateEventTranslation
}

export const deleteEventTraslation = async (eventId, translationLng) => {
  const { data } = await apolloClient.mutate({
    mutation: DELETE_EVENT_TRANSLATION,
    variables: {
      eventId,
      translationLng,
    },
  })

  return data.createOrUpdateEventTranslation
}

export const createProvider = async ({ variables, refetchQueries }) => {
  await apolloClient.mutate({
    mutation: CREATE_PROVIDER,
    variables,
    refetchQueries,
  })
}

export const updateProvider = async ({ variables, refetchQueries }) => {
  await apolloClient.mutate({
    mutation: UPDATE_PROVIDER,
    variables,
    refetchQueries,
  })
}

export const deleteProvider = async ({ providerId, refetchQueries }) => {
  await apolloClient.mutate({
    mutation: DELETE_PROVIDER,
    variables: { providerId },
    refetchQueries,
  })
}

export const restoreProvider = async ({ providerId, refetchQueries }) => {
  await apolloClient.mutate({
    mutation: RESTORE_PROVIDER,
    variables: { providerId },
    refetchQueries,
  })
}

export const createReferral = async ({ eventId, name, refetchQueries }) => {
  await apolloClient.mutate({
    mutation: CREATE_REFERRAL,
    variables: { eventId, name },
    refetchQueries,
  })
}

export const deleteReferralMutation = async ({ eventId, id, refetchQueries }) => {
  await apolloClient.mutate({
    mutation: DELETE_REFERRAL,
    variables: { id, eventId },
    refetchQueries,
  })
}

export const createEvent = async ({ event, refetchQueries }) => {
  return apolloClient.mutate({
    mutation: CREATE_EVENT,
    variables: { event },
    refetchQueries,
  })
}
export const changeEventVenue = async variables => {
  return apolloClient.mutate({
    mutation: CHANGE_EVENT_VENUE,
    variables,
  })
}
export const resetVenueAvailability = async variables => {
  return apolloClient.mutate({
    mutation: RESET_VENUE_AVAILABILITY,
    variables,
  })
}

export const getAccreditationCount = async eventId => {
  const { data } = await apolloClient.query({
    query: ACCREDITATION_COUNT,
    variables: { eventId },
  })

  return data.getEvent
}

export const createHall = async variables => {
  const { data } = await apolloClient.mutate({
    mutation: CREATE_HALL,
    variables,
  })

  return (data || {}).createHall
}

export const deleteHall = async ({ hallId }) => {
  const { data } = await apolloClient.mutate({
    mutation: DELETE_HALL,
    variables: {
      hallId,
    },
  })

  return (data || {}).deleteAnnouncement
}

export const updateHall = async ({ hallId, input }) => {
  const { data } = await apolloClient.mutate({
    mutation: UPDATE_HALL,
    variables: {
      hallId,
      input,
    },
  })

  return (data || {}).updateHall
}

export const createAnnouncement = async (eventId, input) => {
  return apolloClient.mutate({
    mutation: CREATE_ANNOUNCEMENT,
    variables: {
      eventId,
      input,
    },
  })
}

export const getAnnouncements = async eventId => {
  const { data } = await apolloClient.query({
    query: GET_EVENT_ANNOUNCEMENT,
    variables: { eventId },
  })

  return (data || {}).getAnnouncements
}

export const getAnnouncement = async (eventId, id) => {
  const { data } = await apolloClient.query({
    query: GET_ANNOUNCEMENT,
    variables: {
      eventId,
      id,
    },
  })

  return (data || {}).getAnnouncement
}

export const deleteAnnouncement = async ({ eventId, id }) => {
  const { data } = await apolloClient.mutate({
    mutation: DELETE_ANNOUNCEMENT,
    variables: {
      eventId,
      id,
    },
  })

  return (data || {}).deleteAnnouncement
}

export const createWorkshop = async (eventId, workshopData) => {
  const { data } = await apolloClient.mutate({
    mutation: CREATE_WORKSHOP,
    variables: {
      eventId,
      workshopData,
    },
  })

  return (data || {}).createWorkshop
}

export const deleteWorkshop = async (eventId, workshopId) => {
  const { data } = await apolloClient.mutate({
    mutation: DELETE_WORKSHOP,
    variables: {
      eventId,
      workshopId,
    },
  })

  return (data || {}).deleteWorkshop
}

export const updateWorkshop = async ({ eventId, workshopData, refetchQueries }) => {
  const { data } = await apolloClient.mutate({
    mutation: UPDATE_WORKSHOP,
    variables: {
      eventId,
      workshopData,
    },
    refetchQueries,
  })

  return (data || {}).updateWorkshop
}

export const removeWorkshopAttendee = async ({
  eventId,
  workshopId,
  attendeeId,
  refetchQueries,
}) => {
  const { data } = await apolloClient.mutate({
    mutation: REMOVE_WORKSHOP_ATTENDEE,
    variables: {
      eventId,
      workshopId,
      attendeeId,
    },
    refetchQueries,
  })

  return (data || {}).removeWorkshopAttendee
}

export const createTrialAccount = async (userInfo, refetchQueries) => {
  return apolloClient.mutate({
    mutation: CREATE_TRIAL_ACCOUNT,
    variables: { userInfo },
    refetchQueries,
  })
}
export const signUp = async (userInfo, inviteToken, refetchQueries) => {
  return apolloClient.mutate({
    mutation: SIGN_UP,
    variables: { userInfo, inviteToken },
    refetchQueries,
  })
}

export const saveAttendeeFields = async ({ eventId, attendeeFields }, refetchQueries) => {
  return apolloClient.mutate({
    mutation: SAVE_ATTENDEE_FIELDS,
    variables: {
      eventId,
      attendeeFields,
    },
    refetchQueries,
  })
}

export const toggleEventApplications = async ({ eventId, applicationsOpen, refetchQueries }) => {
  return apolloClient.mutate({
    mutation: TOGGLE_EVENT_APPLICATIONS,
    variables: { eventId, applicationsOpen },
    refetchQueries,
  })
}

export const getAttendeeByBarcode = async (barcode, eventId) => {
  return apolloClient.query({
    query: GET_ATTENDEE_BY_BARCODE,
    variables: { barcode, eventId },
  })
}

export async function getExportToken(eventId) {
  return axiosInstance.get(`files/events/${eventId}/export-token`)
}

export async function getSubscribersExportToken(organizationSlug) {
  return axiosInstance.get(`files/organization/${organizationSlug}/export-token`)
}

export async function getTicketSellerAdminExportToken(ticketSellerOrganizationId) {
  return axiosInstance.get(
    `files/ticket-seller-organization-admin/${ticketSellerOrganizationId}/export-token`,
  )
}

export async function getOrder(orderId) {
  const { data } = await apolloClient.query({
    query: GET_ORDER,
    variables: {
      orderId: orderId,
    },
  })

  return (data || {}).getOrder
}

export async function getAttendee(attendeeId, eventId) {
  const { data } = await apolloClient.query({
    query: GET_ATTENDEE,
    variables: {
      eventId: eventId,
      attendeeId: attendeeId,
    },
  })

  return (data || {}).getAttendee
}

export async function getAttendeeWorkshops(attendeeId) {
  const { data } = await apolloClient.query({
    query: GET_ATTENDEE_WORKSHOPS,
    variables: {
      attendeeId: attendeeId,
    },
  })

  return (data || {}).getAttendeeWorkshops
}

export async function createOrder(eventId) {
  const { data } = await apolloClient.mutate({
    mutation: CREATE_ORDER,
    variables: {
      eventId: eventId,
    },
  })

  return (data || {}).createOrder
}

export async function updateOrder(orderId, input) {
  const { data } = await apolloClient.mutate({
    mutation: UPDATE_ORDER,
    variables: {
      orderId: orderId,
      input: input,
    },
  })

  return (data || {}).updateOrder
}

export async function createPurchase(orderId, attendeeId, orderItemId) {
  return await apolloClient.mutate({
    mutation: CREATE_PURCHASE,
    variables: {
      orderId: orderId,
      attendeeId: attendeeId,
      orderItemId: orderItemId,
    },
  })
}

export async function getEventSettings(eventId) {
  const { data } = await apolloClient.query({
    query: GET_EVENT_SETTINGS,
    variables: {
      id: eventId,
    },
  })

  return (data || {}).getEvent
}

export async function getEventAds(eventId) {
  const { data } = await apolloClient.query({
    query: GET_EVENT_ADS,
    variables: {
      eventId,
    },
  })

  return (data || {}).getEventAds
}

export async function getOrderItem(orderItemId) {
  const { data } = await apolloClient.query({
    query: GET_ORDER_ITEM,
    variables: {
      orderItemId: orderItemId,
    },
  })

  return (data || {}).getOrderItem
}

export async function getPurchaseSignature(purchase, eventId) {
  const { data } = await apolloClient.query({
    query: GET_PURCHASE_SIGNATURE,
    variables: {
      purchase: purchase,
      eventId: eventId,
    },
  })

  return (data || {}).getPurchaseSignature
}

export async function getWSPurchaseSignature(shoppingCartId, amount) {
  const { data } = await apolloClient.query({
    query: GET_WS_PURCHASE_SIGNATURE,
    variables: {
      shoppingCartId,
      amount,
    },
  })

  return (data || {}).getWSPayPurchaseSignature
}

export async function createOrderItem(orderItem, eventId) {
  const { data } = await apolloClient.mutate({
    mutation: CREATE_ORDER_ITEM,
    variables: {
      eventId: eventId,
      input: orderItem,
    },
  })

  return (data || {}).createOrderItem
}

export async function createGratisTickets(eventId, orderItem, seats) {
  const { data } = await apolloClient.mutate({
    mutation: CREATE_GRATIS_ORDER_ITEM,
    variables: {
      eventId: eventId,
      input: orderItem,
      seats: seats,
    },
  })

  return (data || {}).createGratisOrderItem
}

export async function updateOrderItem(orderItem, orderItemId, organizationSlug) {
  const { data } = await apolloClient.mutate({
    mutation: UPDATE_ORDER_ITEM,
    variables: {
      orderItemId,
      input: orderItem,
      organizationSlug,
    },
  })

  return (data || {}).updateOrderItem
}

export async function createPromoCode(eventId, ticketId, promoCode) {
  const { data } = await apolloClient.mutate({
    mutation: CREATE_PROMO_CODE,
    variables: {
      eventId: eventId,
      orderItemId: ticketId,
      input: promoCode,
    },
  })

  return (data || {}).createPromoCode
}

export async function updatePromoCode(eventId, promoCodeId, promoCode) {
  const { data } = await apolloClient.mutate({
    mutation: UPDATE_PROMO_CODE,
    variables: {
      eventId,
      promoCodeId,
      input: promoCode,
    },
  })

  return (data || {}).updatePromoCode
}

export async function deletePromoCode(eventId, promoCodeId) {
  const { data } = await apolloClient.mutate({
    mutation: DELETE_PROMO_CODE,
    variables: {
      eventId,
      promoCodeId: promoCodeId,
    },
  })

  return (data || {}).deletePromoCode
}

export async function deletePromoCodes(eventId, promoCodeIds) {
  const { data } = await apolloClient.mutate({
    mutation: DELETE_PROMO_CODES,
    variables: { eventId, promoCodeIds: promoCodeIds },
  })

  return (data || {}).deletePromoCodes
}
export async function getPromoCodeByName(promoCode, eventId) {
  const { data, errors } = await apolloClient.query({
    query: GET_PROMO_CODE_BY_NAME,
    variables: {
      promoCode: promoCode,
      eventId: eventId,
    },
  })

  return { data, errors }
}

export async function getOrderInfoByOrderNumber(orderId) {
  const { data } = await apolloClient.query({
    query: GET_ORDER_INFO_BY_ORDER_NUMBER,
    variables: {
      orderId: orderId,
    },
  })

  return (data || {}).getOrderInfoByOrderNumber
}

export async function finishOrder(orderId, input) {
  const { data } = await apolloClient.mutate({
    mutation: FINISH_ORDER,
    variables: {
      orderId: orderId,
      input: input,
    },
  })

  return (data || {}).finishOrder
}

export const getUserType = async () => {
  const user = await getUser()

  if (!user) {
    return null
  }

  for (let [userType, data] of Object.entries(routingUserModelTypes)) {
    if (data.names.includes(user.type)) {
      return userType
    }
  }
}

//  Translations

export const createEventTranslation = async ({ eventId, translation }, refetchQueries) => {
  return apolloClient.mutate({
    mutation: CREATE_EVENT_TRANSLATION,
    variables: {
      eventId,
      translation,
    },
    refetchQueries,
  })
}

export const getTicketSellerOrganization = async () => {
  const { data } = await apolloClient.query({
    query: GET_TICKET_SELLER_ORGANIZATION,
  })

  return (data.getTicketSellerOrganization || {}).type
}
